module.exports = __webpack_public_path__ + "img/B3-3.dc7852c9.jpg";